module.exports = __webpack_public_path__ + "static/img/klaerwerk.9ca82eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ITZ_Klaerwerk/klaerwerk.jpg
// module id = 323/
// module chunks = 0